let storeRegionOptions = document?.getElementById("region-oms-store");
let storeComunaOptions = document?.getElementById("comuna-oms-store");

let cities = [];

let regionSequence = [{
    name: "Santiago",
    sequence: 0
  },
  {
    name: "Biobío",
    sequence: 1
  },
  {
    name: "La Araucanía",
    sequence: 2
  },
  {
    name: "Los Lagos",
    sequence: 3
  },
  {
    name: "Aysén",
    sequence: 4
  },
];

const searchRegionBySelection = (shopify_code) => {
  if (shopify_code) {
    const _result = stores.filter(
      (store) => store.state.shopify_code === shopify_code
    );
    renderStores(_result);
  }
};

const getRegionsOms = async (urlParam) => {
  const url = `${baseUrlOMS}/api/v1/state/?${urlParam}=true`;

  await axios
    .get(`${url}`, {
      responseType: "json",
      Headers: {
        "Access-Control-Allow-Origin": "*"
      },
    })
    .then(async function (res) {
      if (res.status == 200) {
        let regionsResponse = res.data.states;

        $("#region-oms-store option:not(:first)").remove();

        if (urlParam === "store") {
          regionsResponse.forEach((state, index) => {
            const matchingRegion = regionSequence.find(
              (region) => region.name === state.name
            );
            state.sequence = matchingRegion ?
              matchingRegion.sequence :
              index + 1;
          });
          regionsResponse = regionsResponse.sort(
            (a, b) => a.sequence - b.sequence
          );
        }

        regionsResponse.forEach((element) => {
          const option = document.createElement("option");
          option.setAttribute("data-info", JSON.stringify(element));
          option.setAttribute("data-code-shopify", element.shopify_code);
          option.value = element.shopify_code;
          option.innerText = element.name;
          option?.addEventListener("change", (e) => {
            selectedRegionOms(element, urlParam);
          });
          urlParam === "store" && $("#region-oms-store").append(option);
        });

      }
    })
    .catch(function (err) {
      console.log(err);
    });
};

const getCityByRegionOms = async (
  idRegion,
  modal,
  saveCities = false,
  urlParam
) => {
  await axios
    .get(`${baseUrlOMS}/api/v1/${idRegion}/city/?${urlParam}=true`, {
      responseType: "json",
      Headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then(function (res) {
      if (res.status == 200) {
        cities = res.data.cities.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
        setOptionCities(cities, modal);

        if (!saveCities && modal === "store") {
          setStorageModalStore();
        }
      }
    })
    .catch(function (err) {
      console.log(err);
    });
};

const setOptionCities = (cities, modal) => {
  let wrapper = document.getElementById("select-comune-store");
  let comuneEl = document.getElementById("comuna-oms-store");

  $("#comuna-oms-store option:not(:first)").remove();

  cities.forEach((element) => {
    const option = document.createElement("option");
    option.innerText = element.name;
    option.setAttribute("data-info", JSON.stringify(element));
    option.value = element.code;
    option?.addEventListener("change", (e) => {
      comuneEl.firstElementChild.innerText = element.name;
      comuneEl.setAttribute("data-info", JSON.stringify(element));
      wrapper.classList.toggle("active");
      changeRegionFilterStore(element);
    });
    modal === "store" && storeComunaOptions.appendChild(option);
  });
};

const selectedRegionOms = (option, urlParam) => {
  const idRegion = option?.id ?? option?.code;

  if (urlParam === "store") {
    searchRegionBySelection(option.shopify_code);
    return getCityByRegionOms(idRegion, urlParam, true, urlParam);
  }
};
